import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, Params, Actions, Menu } from 'nallian-table-builder-ui';
import { Modal, Mo, Button } from 'nallian-shared-ui/lib/components';
import { INFINITE_SCROLL, PENDING_INVITATIONS_RESOURCE, PRINCIPAL_ACTIONS } from '../../constants';
import resendInvatationService from '../../services/pendingInvitations/resendInvitationService';
import apiRoutes from '../../../../app/api/routes';

const PENDING_INVITATION_RIGHTS = [
  'PENDINGINVITATIONS.MANAGE.ALL',
  'PENDINGINVITATIONS.MANAGE.ALL.EXCEPTSYSTEMORGS',
  'PENDINGINVITATIONS.MANAGE.ORGANISATION',
];

const PendingInvitations = ({
  organisationId,
  urlRoot,
  dispatchResendInvitationPut,
  resendInvitationFetch,
  forbidManageBecauseSystemOrg,
}) => {
  const { t } = useTranslation();
  const [reinviteUser, setReinviteUser] = useState();
  const handleClearRenviteUser = useCallback(() => setReinviteUser(undefined), [setReinviteUser]);
  const handleSetReinviteUser = useCallback((_, item) => setReinviteUser(item), [setReinviteUser]);

  const handleReinvite = useCallback(
    () =>
      dispatchResendInvitationPut(
        reinviteUser?.id,
        handleClearRenviteUser,
        handleClearRenviteUser,
        t
      ),
    [handleClearRenviteUser, reinviteUser, dispatchResendInvitationPut, t]
  );

  return (
    <>
      <Table
        infiniteScroll={INFINITE_SCROLL}
        resource={PENDING_INVITATIONS_RESOURCE}
        url={apiRoutes.pendingInvitations(organisationId)}
        noResultsMessage={t('noPendingInvitationsFound')}
        rootTableProperty="invitations"
        pageSize={50}
        noUserSettings
        resizable
      >
        <Actions.Link
          label=" "
          icon="eye"
          width="2.5rem"
          align="center"
          name="inviteePrincipalId"
          url={`${urlRoot}/users/${PRINCIPAL_ACTIONS.EDIT}/:inviteePrincipalId`}
        />
        <Params.String name="fullName" width="12rem" minWidth="12rem" grow />
        <Params.String name="email" width="16rem" minWidth="16rem" noFilter grow />
        <Params.DateTime name="invitationSentOn" width="12rem" noFilter />
        <Params.DateTime name="invitationExpiresOn" width="12rem" noFilter />
        <Params.Lookup
          url={apiRoutes.pendingInvitationTypes()}
          name="invitationType"
          width="8rem"
          grow
          noFilter
        />
        <Params.Lookup
          url={apiRoutes.pendingInvitationStates()}
          name="invitationState"
          width="8rem"
          grow
          noFilter
        />
        {!forbidManageBecauseSystemOrg && (
          <Menu width="3.5rem" align="center" hasSomeRights={PENDING_INVITATION_RIGHTS}>
            <Actions.Button onClick={handleSetReinviteUser} label="reInvite" icon="redo" />
            <Actions.Delete url={`${apiRoutes.pendingInvitation()}/:id`} />
          </Menu>
        )}
      </Table>
      {reinviteUser && (
        <Modal open basic size="tiny">
          <Mo.Header>{t('areYouSureReinvite', { userName: reinviteUser.email })}</Mo.Header>
          <Mo.Actions>
            <Button onClick={handleClearRenviteUser} inverted content={t('cancel')} />
            <Button
              primary
              inverted
              color="green"
              onClick={handleReinvite}
              loading={resendInvitationFetch.pending}
              disabled={resendInvitationFetch.pending}
              icon="checkmark"
              content={t('confirm')}
            />
          </Mo.Actions>
        </Modal>
      )}
    </>
  );
};

PendingInvitations.propTypes = {
  organisationId: PropTypes.string.isRequired,
  urlRoot: PropTypes.string.isRequired,
  dispatchResendInvitationPut: PropTypes.func.isRequired,
  resendInvitationFetch: PropTypes.object.isRequired,
  forbidManageBecauseSystemOrg: PropTypes.bool.isRequired,
};

export default resendInvatationService(PendingInvitations);
